import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ConfirmType = 'danger' | 'warning' | 'info'

export interface ConfirmOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  type?: ConfirmType
}

export const useConfirmStore = defineStore('confirm', () => {
  const isOpen = ref(false)
  const title = ref('Confirm Action')
  const message = ref('')
  const confirmText = ref('Confirm')
  const cancelText = ref('Cancel')
  const type = ref<ConfirmType>('danger')

  let resolvePromise: ((value: boolean) => void) | null = null

  const open = (options: ConfirmOptions | string): Promise<boolean> => {
    if (typeof options === 'string') {
      message.value = options
      title.value = 'Confirm Action'
      confirmText.value = 'Confirm'
      cancelText.value = 'Cancel'
      type.value = 'danger'
    } else {
      message.value = options.message
      title.value = options.title || 'Confirm Action'
      confirmText.value = options.confirmText || 'Confirm'
      cancelText.value = options.cancelText || 'Cancel'
      type.value = options.type || 'danger'
    }

    isOpen.value = true

    return new Promise<boolean>((resolve) => {
      resolvePromise = resolve
    })
  }

  const handleConfirm = () => {
    isOpen.value = false
    if (resolvePromise) {
      resolvePromise(true)
      resolvePromise = null
    }
  }

  const handleCancel = () => {
    isOpen.value = false
    if (resolvePromise) {
      resolvePromise(false)
      resolvePromise = null
    }
  }

  return {
    isOpen,
    title,
    message,
    confirmText,
    cancelText,
    type,
    open,
    handleConfirm,
    handleCancel,
  }
})

export function useConfirm() {
  const store = useConfirmStore()
  return {
    confirm: store.open,
  }
}
